import 'globalthis/auto'
import { createApp } from 'vue'
import App1 from './App.vue'
import router from './router'
import store from './store'
import api from './plugin/axiosApi'
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'

App.addListener('backButton', ({ canGoBack }) => {
    if(canGoBack){
      window.history.back()
    } else {
      App.exitApp()
    }
  })


const app = createApp(App1)

// --- catch links from outside -----------------------
if (Capacitor.isNativePlatform()) {
  const handleUrl = async (url) => {
    try {
      const incomingUrl = new URL(url)

      // Only handle links from your own website
      if (incomingUrl.hostname !== 'wedio.sassayer.com') return

      const path =
        incomingUrl.pathname +
        incomingUrl.search +
        incomingUrl.hash

      await router.isReady()
      await router.push(path)
    } catch (error) {
      console.error('Could not handle incoming app link:', error)
    }
  }

  // App already running or returning to foreground
  App.addListener('appUrlOpen', ({ url }) => {
    handleUrl(url)
  })

  // App launched from a completely closed state
  App.getLaunchUrl().then((launch) => {
    if (launch?.url) {
      handleUrl(launch.url)
    }
  })
}



// Make Axios instance available globally
app.config.globalProperties.$axios = api

// Optional: provide globally for composition API
app.provide("axios", api)

app.mixin({
  methods: {
    ExitCapacitorApp : function () {
      App.exitApp()
    },
  },
}).use(store).use(router).mount('#app')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => console.log('SW registered:', reg.scope))
      .catch(err => console.warn('SW registration failed:', err))
  })
}